export class GetUniformOperationalTeamModel {
  [key: string]: number;

  public pantsQuantity: number = 0;
  public pantsUnitCost: number = 0;
  public pantsMonthlyCost: number = 0;
  public pantsHarvestCost: number = 0;

  public shirtQuantity: number = 0;
  public shirtUnitCost: number = 0;
  public shirtMonthlyCost: number = 0;
  public shirtHarvestCost: number = 0;

  public bootsQuantity: number = 0;
  public bootsUnitCost: number = 0;
  public bootsMonthlyCost: number = 0;
  public bootsHarvestCost: number = 0;

  public glovesQuantity: number = 0;
  public glovesUnitCost: number = 0;
  public glovesMonthlyCost: number = 0;
  public glovesHarvestCost: number = 0;

  public glassesQuantity: number = 0;
  public glassesUnitCost: number = 0;
  public glassesMonthlyCost: number = 0;
  public glassesHarvestCost: number = 0;

  public helmetQuantity: number = 0;
  public helmetUnitCost: number = 0;
  public helmetMonthlyCost: number = 0;
  public helmetHarvestCost: number = 0;

  public hygieneKitQuantity: number = 0;
  public hygieneKitUnitCost: number = 0;
  public hygieneKitMonthlyCost: number = 0;
  public hygieneKitHarvestCost: number = 0;

  public hearingProtectionQuantity: number = 0;
  public hearingProtectionUnitCost: number = 0;
  public hearingProtectionMonthlyCost: number = 0;
  public hearingProtectionHarvestCost: number = 0;

  public leggingsQuantity: number = 0;
  public leggingsUnitCost: number = 0;
  public leggingsMonthlyCost: number = 0;
  public leggingsHarvestCost: number = 0;

  public sweatshirtQuantity: number = 0;
  public sweatshirtUnitCost: number = 0;
  public sweatshirtMonthlyCost: number = 0;
  public sweatshirtHarvestCost: number = 0;
  
  public raincoatQuantity: number = 0;
  public raincoatUnitCost: number = 0;
  public raincoatMonthlyCost: number = 0;
  public raincoatHarvestCost: number = 0;
}
